var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1758240668134,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 107088,
    width: 16,
    height: 16,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M896 170.666667h-170.666667V85.333333h-85.333333v85.333334H384V85.333333H298.666667v85.333334H128a42.666667 42.666667 0 0 0-42.666667 42.666666v682.666667a42.666667 42.666667 0 0 0 42.666667 42.666667h768a42.666667 42.666667 0 0 0 42.666667-42.666667V213.333333a42.666667 42.666667 0 0 0-42.666667-42.666666z m-42.666667 682.666666H170.666667V426.666667h682.666666v426.666666z m0-512H170.666667V256h128v42.666667h85.333333V256h256v42.666667h85.333333V256h128v85.333333z",
    fill: "#07c160",
    "p-id": 107089
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M712.832 542.165333l-60.330667-60.330666L469.333333 665.002667l-55.168-55.168-60.330666 60.330666L469.333333 785.664z",
    fill: "#07c160",
    "p-id": 107090
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCheck);
export default __webpack_public_path__ + "static/media/calendar-check.1acf20fc.svg";
export { ForwardRef as ReactComponent };